import PropTypes from "prop-types";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "../../styles/createTest/AddAudience.css";

/**
 * Just a simple button with a FontAwesome label on the left and .iconButton
 * styling. `icon` and `label` are the only required props. Any remaining props
 * will be placed on the root element.
 */
export default class IconButton extends React.PureComponent {
    static propTypes = {
        icon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    };

    render() {
        // we assume the onClick handler is in otherProps
        const {
            className: userClassName,
            icon,
            label,
            ...otherProps
        } = this.props;
        return (
            <button
                className={`${styles.iconButton} ${userClassName || ""}`}
                {...otherProps}
            >
                <FontAwesomeIcon className={styles.icon} icon={icon} /> {label}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/IconButton.js